<template>
  <div class="container">
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-6">
          <div class="row mb-2">
            <label class="col-form-label col-md-4 required">{{
              $t('invoice.studentName')
            }}</label>
            <div class="col-md-8">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                :value="academic.student_name"
              />
              <div class="validate" v-if="errors.has('student_id')">
                {{ errors.first('student_id') }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-form-label col-md-4 required">{{
              $t('invoice.academicYear')
            }}</label>
            <div class="col-md-8">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                :value="academic.ac_year"
              />
              <div class="validate" v-if="errors.has('ac_year_id')">
                {{ errors.first('ac_year_id') }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-form-label col-md-4 required">{{
              $t('invoice.mainProgram')
            }}</label>
            <div class="col-md-8">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                :value="academic.main_program"
              />
              <div class="validate" v-if="errors.has('acp_id')">
                {{ errors.first('acp_id') }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-form-label col-md-4 required">{{
              $t('invoice.acTerm')
            }}</label>
            <div class="col-md-8">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                :value="academic.ac_term"
              />
              <small
                v-if="model.ac_term_stop_date"
                class=" ts-pl-1 ts-rounded-bl-sm ts-font-semibold ts-border-b ts-border-l ts-border-yellow-500 ts-text-blue-600 ts-text-xs"
                >{{
                  $t('invoice.endDate') + ' : ' + model.ac_term_stop_date
                }}</small
              >
              <div class="validate" v-if="errors.has('ac_term')">
                {{ errors.first('ac_term') }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-form-label col-md-4 required">{{
              $t('invoice.grade')
            }}</label>
            <div class="col-md-8">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                :value="academic.grade"
              />
              <div class="validate" v-if="errors.has('grade_id')">
                {{ errors.first('grade_id') }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-form-label col-md-4 required">{{
              $t('invoice.studyTime')
            }}</label>
            <div class="col-md-8">
              <input
                type="text"
                readonly
                class="form-control-plaintext"
                :value="academic.study_time"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row mb-2">
            <label class="col-form-label col-md-4 required">{{
              $t('invoice.invoiceDate')
            }}</label>
            <div class="col-md-8">
              <a-date-picker
                :style="{ width: '100%' }"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                v-model="model.inv_date"
                @change="onChangeInvoiceDate"
              />
              <div class="validate" v-if="errors.has('inv_date')">
                {{ errors.first('inv_date') }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-form-label col-md-4">{{
              $t('invoice.proExpDate')
            }}</label>
            <div class="col-md-8">
              <a-date-picker
                v-model="model.promtion_expired_date"
                :disabled="true"
                :style="{ width: '100%' }"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
              />
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-form-label col-md-4">{{
              $t('invoice.remark')
            }}</label>
            <div class="col-md-8">
              <textarea
                v-model="model.remark"
                rows="3"
                class="form-control"
              ></textarea>
            </div>
          </div>
          <div class="row mb-2" v-if="vehicleRegister">
            <label class="col-form-label col-md-4"></label>
            <div class="col-md-8">
              <small class="text-red"
                ><i class="fa fa-bus"></i>
                {{ $t('invoice.studnetTakeBuseFee') }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'academicInfo',
  props: ['value', 'academic', 'validate', 'vehicleRegister'],
  data () {
    return {
      model: {},
      errors: new Errors()
    }
  },
  computed: {
    ...mapState('invoice', ['defaultCreditDay'])
  },
  created () {
    this.model = this.value
  },
  methods: {
    onChangeInvoiceDate () {
      this.model.amount_due = _.round(
        this.model.total_amount - this.model.amount_paid,
        2
      )
      if (this.model.amount_due > 0) {
        this.model.next_payment_date = moment(this.model.inv_date, 'DD-MM-YYYY')
          .add(this.defaultCreditDay, 'days')
          .format('DD-MM-YYYY')
      } else {
        this.model.next_payment_date = null
      }
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  max-height: 35vh;
  height: 30vh;
}
</style>
